import React from 'react';
import Screen from '../../components/common/Screen';
import Title from '../../components/common/Title';
import { useTranslation } from 'react-i18next';
import Card from '../../components/elements/Card';
import { useEffect, useState } from 'react';
import { fetchUserInfo, handleImageUpload, handleDeleteImage, teamPhoto } from '../../utils';
import Button from '../../components/elements/Button';
import SameLine from '../../components/css/SameLine';
import Image from '../../components/images/Image';
import InputField from '../../components/forms/InputField';
import Center from '../../components/css/Center';
import { useNavigate } from 'react-router-dom';
import TextArea from '../../components/forms/TextArea';
import Icon from '../../components/common/Icon';
import ImageInput from '../../components/forms/ImageInput';
import TeamPaymentBanner, { useTeamPaymentLock } from '../../components/team/TeamPaymentLock';

const Page = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showToast, setShowToast] = useState(false); 
  // Same team the form edits (session Otherteamid, else your own) — unpaid means read-only.
  const payLock = useTeamPaymentLock();

  useEffect(() => {
    fetchUserInfo('/edit-team', setUserInfo, setLoading, setError, []);
  }, []);

  const onSubmit = async (event) => {
      event.preventDefault();
      
      const formData = new FormData(event.target);
      const values = Object.fromEntries(formData.entries());

      const otherTeamId = sessionStorage.getItem('otherTeamId');

      try {
        // Only forward Otherteamid when we actually have one. Sending the
        // literal string "null" (what a missing sessionStorage value coerces
        // to) makes the backend treat it as a team id and blow up.
        const headers = { 'Content-Type': 'application/json' };
        if (otherTeamId) headers['Otherteamid'] = otherTeamId;

        const response = await fetch('/api/edit-team', {
            method: 'POST',
            headers,
            body: JSON.stringify(values)
        });

        // Parse defensively: an error response can be non-JSON (e.g. an HTML
        // 500 page), which would otherwise surface as a cryptic
        // "Unexpected token '<'" toast instead of a real message.
        let data = {};
        try { data = await response.json(); } catch { /* non-JSON body */ }

        if (response.ok) {
            navigate(-1); // Go back to wherever they came from, not the public team
        } else {
            throw new Error(data.message || 'somethingWentWrong');
        }
    } catch (error) {
        console.error('Error:', error.message);
        setError(error.message || 'somethingWentWrong');
        setShowToast(true);
    }

  };

  return (
    <form onSubmit={onSubmit}>
    <Screen color='white' p="3" >

      <div className="top">
        <Title>{t('yourTeam')}</Title>
        <TeamPaymentBanner lock={payLock} />
      
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }} className='mb-4'>

        <ImageInput 
          onUpload={(file) => handleImageUpload(file, '/api/upload-team-image', setError, setShowToast)} 
          onDelete={() => handleDeleteImage('/delete-team-image', setError, setShowToast)}
          caption={t('editPicture')} 
          url={teamPhoto(userInfo?.picture)}
          deleteLabel={t('deletePicture')}
        />


        {/* <div className='text-secondary mt-1'>
          <Icon name='info' style={{ color:'red'}} className='me-1' />
          {t('timeForChangesInfo')}
        </div> */}
        </div>
      
        {userInfo && (
          <>
            <InputField type="text" name="name" label={t("teamName")} placeholder={t("teamName")} value={userInfo.name} required />
            <InputField type="text" name="slogan" label={t("slogan")} placeholder={t("enterSlogan")} value={userInfo.slogan} />
            <TextArea type="text" name="bio" label={t("bio")} placeholder={t("enterBio")} value={userInfo.bio} />
            <InputField type="text" name="song_id" label={t("song")} placeholder={"https://www.youtube.com/watch?v="} value={userInfo.song_url} />
            <InputField type="text" name="whatsapp_url" label={t("whatsappGroup")} placeholder={"https://chat.whatsapp.com/…"} value={userInfo.whatsapp_url} />
            <div className='text-secondary mb-3' style={{ fontSize: '0.85rem' }}>
              {t('whatsappGroupHelp')}
            </div>
            {/* Roster management lives on the players screen now (merge included).
                A jump-off from here keeps it discoverable. */}
            <div className='mb-3'>
              <Button to="/players" theme='secondary' className='mb-2'>
                <Icon name='users' className='me-2' /> {t('editPlayers')}
              </Button>
              <div className='text-secondary' style={{ fontSize: '0.85rem' }}>{t('editPlayersHint')}</div>
            </div>
          </>
        )}

        {/* Bootstrap Toast Notification */}
        <div className="toast-container p-3"  >
          <div className={`toast ${showToast ? 'show' : 'hide'}`} role="alert" aria-live="assertive" aria-atomic="true">
            <div className="toast-header">
              <Icon name="exclamation" theme="primary" className="me-2" />
              <strong className="me-auto">{t(error)}</strong>
              <button type="button" className="btn-close" onClick={() => setShowToast(false)}></button>
            </div>
          </div>
        </div>
      </div>

      <div className="bottom">
        <div className="px-3">
          <hr className="mb-3" />
          <Button type='submit' className='mb-3' disabled={!!payLock}>
            {t("done")}
          </Button>
        </div>
      </div>
    </Screen>
    </form>
  );
};

export default Page;